"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { Info, CircleDollarSign, Mail, LogIn, PenLine, LayoutDashboard, Compass } from "lucide-react";
import { MobileNavSheet, MobileNavItem } from "@/components/layout/mobile-nav-sheet";
import { useAuth } from "@/providers/auth-provider";

/**
 * Mobile-only hamburger menu for the marketing navbar. The nav links are
 * `hidden md:flex` in the bar, so on mobile they (plus Log In / Start Writing)
 * collapse into the shared slide-out sheet — otherwise they'd be unreachable.
 */
export function MarketingMobileMenu() {
  const $ = _c(10);
  const [open, setOpen] = useState(false);
  const {
    user,
    profile,
    loading
  } = useAuth();
  const isAuthor = profile?.canAuthor ?? false;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MobileNavItem href="/about" icon={<Info className="size-5" aria-hidden={true} />}>About</MobileNavItem>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MobileNavItem href="/writer-pricing" icon={<CircleDollarSign className="size-5" aria-hidden={true} />}>Pricing</MobileNavItem>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MobileNavItem href="/contact" icon={<Mail className="size-5" aria-hidden={true} />}>Contact</MobileNavItem>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== isAuthor || $[4] !== loading || $[5] !== user) {
    t3 = loading ? null : user ? isAuthor ? <MobileNavItem href="/editor" icon={<LayoutDashboard className="size-5 text-brand" aria-hidden={true} />}>Dashboard</MobileNavItem> : <MobileNavItem href="/browse" icon={<Compass className="size-5 text-brand" aria-hidden={true} />}>Browse</MobileNavItem> : <><MobileNavItem href="/login" icon={<LogIn className="size-5" aria-hidden={true} />}>Log In</MobileNavItem><MobileNavItem href="/signup/writer" icon={<PenLine className="size-5 text-brand" aria-hidden={true} />}>Start Writing for Free</MobileNavItem></>;
    $[3] = isAuthor;
    $[4] = loading;
    $[5] = user;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== open || $[8] !== t3) {
    t4 = <MobileNavSheet open={open} onOpenChange={setOpen}>{t0}{t1}{t2}{t3}</MobileNavSheet>;
    $[7] = open;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}